const SvgLocationPinIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.668 9a5 5 0 1 1 6 4.9V19a1 1 0 0 1-2 0v-5.1a5 5 0 0 1-4-4.9"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgLocationPinIcon;
